import React from "react"
import Image from "@/common/components/NextImg"
import Sticky from "react-stickynode"
import styled from "styled-components"
import { themeGet } from "@styled-system/theme-get"
import { useTranslation } from "next-i18next"
import { serverSideTranslations } from "next-i18next/serverSideTranslations"
import ResetCSS from "@/common/assets/css/style"
import NavbarNew from "@/containers/common/NavbarNew"
import Footer from "@/containers/common/FooterNew"
import Heading from "@/common/components/_UI/Heading"
import Text from "@/common/components/Text"
import SectionHeading from "@/common/components/SectionHeading"
import SectionLine from "@/common/components/SectionLine"
import GlowBox from "@/common/components/GlowBox"
import Link from "next/link"
import Button from "@/common/components/Button"
import Box from "@/common/components/Box"
import MetaData from "@/common/components/MetaData"
import { AppWrapper } from "@/containers/common/style"
import AboutImage from "@/common/assets/image/about/StudioProductLaunch.webp"
import IntroImage1 from "@/common/assets/image/about/Patent.svg"
import IntroImage2 from "@/common/assets/image/about/ISO.svg"
import IntroImage3 from "@/common/assets/image/about/Award.svg"
import IntroImage4 from "@/common/assets/image/about/CAMS.svg"
import TeamKordan from "@/common/assets/image/about/Team/Kordan.svg"
import TeamHarry from "@/common/assets/image/about/Team/Harry.svg"
import TeamGrace from "@/common/assets/image/about/Team/Grace.svg"
import TeamPippen from "@/common/assets/image/about/Team/Pippen.svg"
import TeamJean from "@/common/assets/image/about/Team/Jean.svg"
import TeamMaggie from "@/common/assets/image/about/Team/Maggie.svg"
import TeamJason from "@/common/assets/image/about/Team/Jason.svg"
import TeamDorara from "@/common/assets/image/about/Team/Dorara.svg"
import TeamKuan from "@/common/assets/image/about/Team/Kuan.svg"
import TeamEstelle from "@/common/assets/image/about/Team/Estelle.svg"
import TeamCharles from "@/common/assets/image/about/Team/Charles.svg"
import TeamBeans from "@/common/assets/image/about/Team/Beans.svg"
import TeamOlivia from "@/common/assets/image/about/Team/Default.svg"
import TeamRaiven from "@/common/assets/image/about/Team/Default.svg"
import TeamAshley from "@/common/assets/image/about/Team/Default.svg"
import TeamChloe from "@/common/assets/image/about/Team/Default.svg"
import TeamArron from "@/common/assets/image/about/Team/Default.svg"

const Fade = require("react-reveal/Fade")

const AboutUs = () => {
  const { t } = useTranslation("aboutUs")

  const INTRO_DATA = [
    { id: 0, image: IntroImage1, title: t("intro.item1") },
    { id: 1, image: IntroImage2, title: t("intro.item2") },
    { id: 2, image: IntroImage3, title: t("intro.item3") },
    { id: 3, image: IntroImage4, title: t("intro.item4") }
  ]
  const TEAM_DATA = [
    {
      id: 0,
      image: TeamKordan,
      name: "Kordan Ou",
      jobtitle: "Founder | CEO"
    },
    {
      id: 1,
      image: TeamHarry,
      name: "Harry Chen",
      jobtitle: "Co-Founder | CTO"
    },
    {
      id: 2,
      image: TeamEstelle,
      name: "Estelle Huang",
      jobtitle: "Head of Product"
    },
    {
      id: 3,
      image: TeamJason,
      name: "Jason Chien",
      jobtitle: "Senior Software Engineer"
    },
    {
      id: 4,
      image: TeamDorara,
      name: "Dorara Hsieh",
      jobtitle: "Senior Flutter Engineer"
    },
    {
      id: 5,
      image: TeamBeans,
      name: "Beans Hung",
      jobtitle: "Full Stack Engineer"
    },
    {
      id: 6,
      image: TeamCharles,
      name: "Charles Chien",
      jobtitle: "Flutter Engineer"
    },
    {
      id: 7,
      image: TeamPippen,
      name: "Pippen Wu",
      jobtitle: "Software Engineer"
    },
    {
      id: 8,
      image: TeamKuan,
      name: "Kuan Pan",
      jobtitle: "Senior Front-end Engineer"
    },
    {
      id: 9,
      image: TeamGrace,
      name: "Grace Wu",
      jobtitle: "Front-end Engineer"
    },
    {
      id: 10,
      image: TeamArron,
      name: "Arron Su",
      jobtitle: "Front-end Engineer"
    },
    {
      id: 11,
      image: TeamRaiven,
      name: "Raiven Kao",
      jobtitle: "Backend Engineer"
    },
    {
      id: 12,
      image: TeamJean,
      name: "Jean Luo",
      jobtitle: "Product Designer"
    },
    {
      id: 13,
      image: TeamChloe,
      name: "Chloe Lim",
      jobtitle: "UI/UX Designer"
    },
    {
      id: 14,
      image: TeamOlivia,
      name: "Olivia Shen",
      jobtitle: "Product Planner"
    },
    {
      id: 15,
      image: TeamMaggie,
      name: "Maggie Lee",
      jobtitle: "Special Assistant"
    },
    {
      id: 16,
      image: TeamAshley,
      name: "Ashley Lin",
      jobtitle: "Partnership Manager"
    }
  ]

  return (
    <div>
      <>
        <MetaData
          title={t("meta.title")}
          description={t("meta.description")}
          url={t("meta.url")}
          image="https://storage.googleapis.com/kryptogo-official-website-public/og-logo.webp"
          languageAlternates={[
            [
              {
                hrefLang: "en-US",
                href: "https://www.kryptogo.com/about-us"
              },
              {
                hrefLang: "zh-TW",
                href: "https://www.kryptogo.com/tw/about-us"
              },
              {
                hrefLang: "zh-CN",
                href: "https://www.kryptogo.com/cn/about-us"
              }
            ]
          ]}
        />

        <ResetCSS />
        {/* end of global and reset style */}

        {/* start app classic landing */}
        <AppWrapper>
          <Sticky top={0} innerZ={1000} activeClass="sticky-active">
            <NavbarNew />
          </Sticky>
          <BGWrapper>
            <GlowBox />
          </BGWrapper>
          <ContainerWrapper>
            <TitleWrapper>
              <SectionHeading title={t("mission.title")} />

              <h2 className="mission">
                {t("mission.content1")}
                <span>{t("mission.highlight1")}</span>
                {t("mission.highlight1.and")}
                <span>{t("mission.highlight2")}</span>
                {t("mission.highlight2.and")}
                <span>{t("mission.highlight3")}</span>
                {t("mission.content2")}
              </h2>
            </TitleWrapper>
            <SectionLine />

            <AboutWrapper>
              <Box className="ImageBox">
                <Heading as="h3" content={t("about.slogan")} />
                <div className="imageWrapper">
                  <Image
                    className="img"
                    alt={t("about.title")}
                    src={AboutImage.src}
                  />
                </div>
              </Box>

              <Box className="TextBox">
                <Fade bottom>
                  <Heading
                    as="h2"
                    className="text-gradient text-glow"
                    content={t("about.title")}
                  />
                  <Text as="p" content={t("about.content1")} />
                  <Text as="p" content={t("about.content2")} />
                </Fade>
              </Box>
            </AboutWrapper>

            <SectionLine />
            <IntroWrapper>
              <Fade bottom>
                <Heading
                  center
                  as="h2"
                  content={t("intro.title")}
                  className="text-gradient text-glow"
                />
              </Fade>
              <ListWrapper className="intro-list">
                {INTRO_DATA.map(intro => (
                  <Box key={`company-box-${intro?.id}`}>
                    <Fade bottom>
                      <Image src={intro.image} alt={intro.title} />

                      <Text as="h5" mt="24px" content={intro.title}></Text>
                    </Fade>
                  </Box>
                ))}
              </ListWrapper>
            </IntroWrapper>
            <SectionLine />
            <TeamWrapper>
              <Fade bottom>
                <Heading
                  as="h2"
                  center
                  content={t("team.title")}
                  className="text-gradient text-glow"
                />
              </Fade>
              <ListWrapper className="team-list">
                {TEAM_DATA.map(team => (
                  <Box key={`company-box-${team?.id}`}>
                    <Fade bottom>
                      <Image src={team.image} alt={team.name} />

                      <Text as="h4" className="name" content={team.name}></Text>
                      <Text as="p" content={team.jobtitle}></Text>
                    </Fade>
                  </Box>
                ))}
              </ListWrapper>
            </TeamWrapper>

            <SectionLine />

            <MoreWrapper>
              <ListWrapper className="more-list">
                <Box>
                  <Text as="h2" mt="24px" content={t("career.title")} />
                  <Text as="p" mt="0px" content={t("career.content")} />
                  <Link href={"/join-us"} passHref legacyBehavior>
                    <Button id="about-us-jobs" title={t("career.button")} />
                  </Link>
                </Box>
                <Box>
                  <Text as="h2" mt="24px" content={t("press.title")} />
                  <Text as="p" mt="0px" content={t("press.content")} />
                  <Link href={"/press"} passHref legacyBehavior>
                    <Button id="about-us-see-more" title={t("press.button")} />
                  </Link>
                </Box>
              </ListWrapper>
            </MoreWrapper>
          </ContainerWrapper>

          <Footer />
        </AppWrapper>
      </>
    </div>
  )
}
export const getStaticProps = async ({ locale }: { locale: string }) => ({
  props: {
    ...(await serverSideTranslations(locale, [
      "aboutUs",
      "contactUs",
      "common"
    ]))
  }
})

export default AboutUs
const ContainerWrapper = styled.div`
  width: 100%;
  overflow: hidden;
`
const TitleWrapper = styled.div`
  padding: 160px 20px 60px;
  @media (max-width: 768px) {
    padding-top: 100px;
    padding-bottom: 30px;
  }
  .mission {
    max-width: 800px;
    line-height: 1.8;
    font-weight: 600;
    font-size: 32px;
    margin-left: auto;
    margin-right: auto;
    text-align: center;
    span {
      color: ${themeGet("colors.secondary")};
      font-weight: 700;
      background: ${themeGet("colors.primary")};
      padding-left: 12px;
      padding-right: 12px;
      margin-right: 12px;
      margin-left: 12px;
    }
    @media (max-width: 768px) {
      font-size: 24px;
    }
  }
`

const AboutWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  z-index: 10;
  padding: 100px 0;
  z-index: 10;
  padding: 0 20px;
  max-width: 1560px;
  margin: 0 auto;

  > div {
    width: 50%;
  }
  @media (max-width: 1024px) {
    > div {
      width: 100%;
    }
  }

  .ImageBox {
    /* height: 600px; */
    position: relative;
    /* background: ${themeGet("colors.secondary")}; */

    .imageWrapper {
      height: 600px;
      opacity: 0.7;
      position: relative;
      @media (max-width: 768px) {
        // padding-top: 80%;
        width: 100%;
        height: auto;
        margin-bottom: 80px;
      }
    }
    h3 {
      font-size: 1.5em;
      padding: 2rem;
      background: ${themeGet("colors.primary")};
      background: linear-gradient(
        -139deg,
        ${themeGet("colors.primaryLight")} 0%,
        ${themeGet("colors.primary")} 75%
      );
      color: ${themeGet("colors.secondary")};
      position: absolute;
      top: -80px;
      left: -20px;
      width: 90%;
      min-width: 350px;
      z-index: 30;

      text-shadow:
        0 0 20px ${themeGet("colors.primary")},
        0 0 5px ${themeGet("colors.primary")};

      &:before {
        content: "“";
        top: 10%;
        left: -5%;
      }
      &:after {
        content: "”";

        right: -5%;
        bottom: -40%;
      }
      &:before,
      &:after {
        font-family: "Serif";
        position: absolute;
        font-size: 120px;
        position: absolute;
        transform: skewX(-10deg);
      }
      @media (max-width: 768px) {
        display: block;
        margin: 0 auto;
        left: auto;
        top: auto;
        right: -20px;
        bottom: 0;
        &:before,
        &:after {
          // display: none;
        }
      }
    }
  }
  .TextBox {
    padding-left: 60px;
    @media (max-width: 1024px) {
      padding-left: 0;
      margin-top: 40px;
    }
    p {
      font-size: 24px;
      letter-spacing: 0.25px;
      margin: 24px 0;
      @media (max-width: 768px) {
        font-size: 18px;
      }
    }
  }
`

const ListWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  max-width: 1200px;
  margin-top: 60px;
  margin-left: auto;
  margin-right: auto;
  flex-wrap: wrap;
  z-index: 10;
`
const IntroWrapper = styled.div`
  text-align: center;
  padding: 160px 40px;
  margin-top: -80px;
  margin-bottom: -80px;
  background: ${themeGet("colors.secondary")};

  @media (max-width: 768px) {
    padding: 120px 20px;
  }

  .intro-list {
    max-width: 1200px;
    > div {
      width: 25%;
      @media (max-width: 1024px) {
        width: 50%;
      }
    }
    img {
      max-width: 150px;
      max-height: 150px;
      width: auto;
      height: auto;
      @media (max-width: 1024px) {
        max-width: 120px;
        max-height: 120px;
      }
    }
  }
`
const TeamWrapper = styled.div`
  text-align: center;
  padding: 100px 40px 60px 40px;
  @media (max-width: 768px) {
    padding: 80px 20px 20px 20px;
  }
  @media (max-width: 640px) {
    padding: 60px 0 20px;
  }
  .team-list {
    // max-width: 1200px;
    justify-content: center;
    > div {
      width: 25%;
      padding: 2rem;
      .name {
        margin-top: 24px;
        margin-bottom: 0;
      }
      @media (max-width: 1024px) {
        width: calc(100% / 3);
        padding: 2rem;
      }
      @media (max-width: 600px) {
        width: 50%;
        padding: 1rem;
        .name {
          margin-top: 12px;
        }
      }
    }
    img {
      width: 100%;
      border-radius: 100%;
      background: linear-gradient(
        -139deg,
        ${themeGet("colors.primaryLight")},
        ${themeGet("colors.primary")}
      );
    }
  }
`
const MoreWrapper = styled.div`
  text-align: center;
  margin-bottom: 60px;
  margin-top: 20px;
  z-index: 10;
  max-width: 1560px;
  margin: 50px auto 20px;
  padding: 0 20px;

  .more-list {
    max-width: 100%;

    > div {
      width: 48%;
      min-height: 400px;
      display: flex;
      align-items: center;
      flex-direction: column;
      justify-content: center;
      padding: 4rem 2rem;
      border-radius: 24px;
      background: linear-gradient(
        -139deg,
        ${themeGet("colors.primaryLight")} 0%,
        ${themeGet("colors.secondary")} 100%
      );
      @media (max-width: 1024px) {
        width: 100%;
        margin: 20px 0;
        min-height: auto;
      }
      button {
        margin-top: 12px;
      }
    }
  }
`
const BGWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -1;
`
